<div class="main">
    <div class="main-container-wrapper">
        <header class="page-heading">
            <div>
                <span class="eyebrow"><i class="bi bi-cpu" aria-hidden="true"></i> ECU configuration</span>
                <h1>ECU Builds</h1>
                <p>Manage canonical names, connected names, accepted names and producers.</p>
            </div>
            <div class="button-container">
                <button type="button" (click)="onRefreshTable()" class="add-row-btn-refresh" aria-label="Refresh ECU Builds" title="Refresh" [disabled]="ecuNamesService.ecuNamesIsLoading()">
                    <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
                </button>
                <button type="button" (click)="toggleInputRow()" class="add-row-btn" [attr.aria-expanded]="ecuNamesService.showInputRow()">
                    <i class="bi bi-plus-lg" aria-hidden="true"></i> ECU Build
                </button>
            </div>
        </header>
        <div class="results-panel">
            <div class="toolbar">
                <label class="search-field">
                    <i class="bi bi-search" aria-hidden="true"></i>
                    <input type="search" [value]="ecuNamesService.searchQuery()" (input)="searchForCorrectEcuNames($event)"
                           placeholder="Search correct, connected or accepted ECU Build names" aria-label="Search ECU Build names" />
                </label>
                <span class="result-count" aria-live="polite">{{ ecuNamesService.ecuNamesFiltered().length }} {{ ecuNamesService.ecuNamesFiltered().length === 1 ? 'build' : 'builds' }}</span>
            </div>
        @defer (when !ecuNamesService.ecuNamesIsLoading()) {
            <div
                #tableContainer
                class="table-container"
                infinite-scroll
                [scrollWindow]="false"
            >
                <table>
                    <thead><tr class="header">
                        <th scope="col">Correct ECU name</th>
                        <th scope="col">Connected ECU names</th>
                        <th scope="col">Accepted ECU names</th>
                        <th scope="col">ECU producer</th>
                        <th scope="col">Actions</th>
                    </tr></thead>
                    <tbody>
                    <tr class="create-row" *ngIf="ecuNamesService.showInputRow()">
                        <td>
                            <mat-form-field class="background-input">
                                <mat-label>Correct Ecu Name</mat-label>
                                <input
                                        type="text"
                                        matInput
                                        (ngModelChange)="onNewTuningNameInput($event)"
                                        [(ngModel)]="ecuNamesService.newRow().correctEcuBuildNames"
                                />
                            </mat-form-field>
                            <div class="duplicate-warning">
                            <span *ngIf="duplicateTuningName">
                                        Tuning name "{{ duplicateValue }}" already exists.
                                   </span>
                            </div>

                        </td>
                        <td>
                            <mat-form-field class="background-input">
                                <mat-label>Connected Ecu Name</mat-label>
                                <input
                                        type="text"
                                        matInput
                                        [(ngModel)]="ecuNamesService.newRow().connectedEcuBuildNames"
                                />
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-form-field class="background-input">
                                <mat-label>Accepted Ecu Name</mat-label>
                                <textarea
                                        type="text"
                                        matInput
                                        [(ngModel)]="ecuNamesService.newRow().acceptedEcuBuildNames"
                                        cdkTextareaAutosize
                                        cdkAutosizeMinRows="1"
                                        cdkAutosizeMaxRows="17"
                                ></textarea>
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-form-field class="ecu-producer-field" subscriptSizing="dynamic">
                                <mat-select
                                        aria-label="ECU producer"
                                        placeholder="Select producer"
                                        panelClass="ecu-producer-panel"
                                        [(value)]="ecuNamesService.newRow().correctEcuProducer"
                                >
                                    <mat-option
                                            *ngFor="let correctEcuProducer of ecuProducersService.correctEcuProducersList()"
                                            [value]="correctEcuProducer"
                                    >
                                        {{ correctEcuProducer }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            @if (!ecuNamesService.isWaitingResponse()) {
                                <button type="button" aria-label="Save new ECU Build" title="Save" (click)="addNewRow()" class="row-btn">
                                    <i class="bi bi-check-lg"></i>
                                </button>
                                <button type="button" aria-label="Cancel adding ECU Build" title="Cancel" (click)="deleteRow()" class="row-btn">
                                    <i class="bi bi-x-lg"></i>
                                </button>
                            } @else {
                                <div class="spinner-wrapper">
                                    <mat-spinner
                                            style="max-width: 100%; max-height: 100%"
                                    ></mat-spinner>
                                </div>
                            }
                        </td>
                    </tr>

                    @for (element of ecuNamesService.ecuNamesFiltered(); track element.id) {
                        <tr class="body-columns" [class.row-editing]="editingDraft?.id === element.id">
                            <td>
                                @if (editingDraft?.id === element.id) {
                                    <input class="inline-edit-field" type="text" aria-label="Correct ECU name"
                                           [(ngModel)]="editingDraft!.correctEcuBuildNames"
                                           (ngModelChange)="onNewTuningNameEdit($event, element.id)" />
                                    @if (duplicateTuningName) { <small class="inline-error">“{{ duplicateValue }}” already exists.</small> }
                                } @else {
                                    <div class="tag-list">
                                        @for (correctName of visibleNames(element.correctEcuBuildNames, element.id, 'correct'); track $index) {
                                            <button type="button" class="tag selectable-tag" title="Select {{ correctName }}"
                                                    (click)="getCorrectEcuBuildName($event)" (dblclick)="editEcu(element)">{{ correctName }}</button>
                                        }
                                        @if (hiddenNamesCount(element.correctEcuBuildNames, element.id, 'correct')) {
                                            <button type="button" class="more-tag" (click)="toggleNames(element.id, 'correct')">+{{ hiddenNamesCount(element.correctEcuBuildNames, element.id, 'correct') }} more</button>
                                        } @else if (canCollapseNames(element.correctEcuBuildNames, element.id, 'correct')) {
                                            <button type="button" class="more-tag" (click)="toggleNames(element.id, 'correct')">Show less</button>
                                        }
                                    </div>
                                }
                            </td>
                            <td>
                                @if (editingDraft?.id === element.id) {
                                    <input class="inline-edit-field" type="text" aria-label="Connected ECU names"
                                           [(ngModel)]="editingDraft!.connectedEcuBuildNames" />
                                } @else {
                                    <div class="tag-list">
                                        @for (connectedName of visibleNames(element.connectedEcuBuildNames, element.id, 'connected'); track $index) {
                                            <span class="tag" (dblclick)="editEcu(element)">{{ connectedName }}</span>
                                        } @empty { <span class="empty-value">—</span> }
                                        @if (hiddenNamesCount(element.connectedEcuBuildNames, element.id, 'connected')) {
                                            <button type="button" class="more-tag" (click)="toggleNames(element.id, 'connected')">+{{ hiddenNamesCount(element.connectedEcuBuildNames, element.id, 'connected') }} more</button>
                                        } @else if (canCollapseNames(element.connectedEcuBuildNames, element.id, 'connected')) {
                                            <button type="button" class="more-tag" (click)="toggleNames(element.id, 'connected')">Show less</button>
                                        }
                                    </div>
                                }
                            </td>
                            <td>
                                @if (editingDraft?.id === element.id) {
                                    <textarea class="inline-edit-field inline-edit-textarea" rows="2" aria-label="Accepted ECU names"
                                              [(ngModel)]="editingDraft!.acceptedEcuBuildNames"></textarea>
                                } @else {
                                    <div class="tag-list">
                                        @for (acceptedName of visibleNames(element.acceptedEcuBuildNames, element.id, 'accepted'); track $index) {
                                            <span class="tag" (dblclick)="editEcu(element)">{{ acceptedName }}</span>
                                        } @empty { <span class="empty-value">—</span> }
                                        @if (hiddenNamesCount(element.acceptedEcuBuildNames, element.id, 'accepted')) {
                                            <button type="button" class="more-tag" (click)="toggleNames(element.id, 'accepted')">+{{ hiddenNamesCount(element.acceptedEcuBuildNames, element.id, 'accepted') }} more</button>
                                        } @else if (canCollapseNames(element.acceptedEcuBuildNames, element.id, 'accepted')) {
                                            <button type="button" class="more-tag" (click)="toggleNames(element.id, 'accepted')">Show less</button>
                                        }
                                    </div>
                                }
                            </td>
                            <td>
                                @if (editingDraft?.id === element.id) {
                                    <mat-form-field class="ecu-producer-field" subscriptSizing="dynamic">
                                        <mat-select aria-label="ECU producer" placeholder="Select producer"
                                                    panelClass="ecu-producer-panel"
                                                    [(value)]="editingDraft!.correctEcuProducer">
                                            @for (producer of ecuProducersService.correctEcuProducersList(); track producer) {
                                                <mat-option [value]="producer">{{ producer }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                } @else {
                                    <span class="tag producer-tag" (dblclick)="editEcu(element)">{{ element.correctEcuProducer || '—' }}</span>
                                }
                            </td>
                            <td class="actions">
                                @if (editingDraft?.id === element.id) {
                                    @if (ecuNamesService.isWaitingResponse()) {
                                        <span class="saving-label">Saving…</span>
                                    } @else {
                                        <button type="button" class="table-buttons" aria-label="Save ECU Build" title="Save"
                                                [disabled]="!editingDraft?.correctEcuBuildNames?.trim() || duplicateTuningName"
                                                (click)="saveEditedItem()"><i class="bi bi-check-lg" aria-hidden="true"></i></button>
                                        <button type="button" class="table-buttons" aria-label="Cancel editing" title="Cancel"
                                                (click)="cancelEdit()"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
                                    }
                                } @else {
                                    <button type="button" class="table-buttons delete-button" aria-label="Delete ECU Build" title="Delete ECU Build"
                                            [disabled]="ecuNamesService.isWaitingResponse()" (click)="deleteItemFromDatabase(element)"><i class="bi bi-trash" aria-hidden="true"></i></button>
                                    <button type="button" class="table-buttons" aria-label="Edit ECU Build" title="Edit ECU Build"
                                            [disabled]="!element.id || ecuNamesService.isWaitingResponse()" (click)="editEcu(element)"><i class="bi bi-pencil" aria-hidden="true"></i></button>
                                }
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="5" class="empty-state"><i class="bi bi-search" aria-hidden="true"></i><strong>No ECU Builds found</strong><span>Try a different search or add a new ECU Build.</span></td>
                        </tr>
                    }
                    </tbody>
                </table>
            </div>
        } @placeholder (minimum 150ms) {
            <div class="skeleton-wrapper">
                <app-skeleton-table></app-skeleton-table>
            </div>
        }
        </div>
    </div>
</div>
